import { Link } from "react-router-dom";

const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <nav className="flex items-center gap-1 text-sm text-gray-600">
      {items.map((item, idx) => {
      const isLast = idx === items.length - 1;

        return (
          <span key={idx} className="flex items-center gap-1">
            {isLast ? (
              <span className="font-semibold text-rs-azul">{item.label}</span>
            ) : (
              <Link to={item.to} className="hover:underline">
                {item.label}
              </Link>
            )}
            {!isLast && <span>/</span>}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
